import React, { Suspense, useEffect } from 'react'
import {
  Redirect,
  Route,
  Switch,
  useHistory
} from 'react-router-dom'
import Loader from "components/Loader";

// routes config
import routes from 'routes/routes'
import { IRoute } from 'interfaces'
import PublicRoute from 'routes/PublicRoute';
import PrivateRoute from 'routes/PrivateRoute';
import { ROLES, mapRole } from "constants/Common";

interface IContent {
  role: string
}

const roleRoutes: any = {
  [ROLES.USER]: routes.userRoute,
  [ROLES.JUDGE]: routes.judgeRoute,
  [ROLES.JUDGECHAIRERSON]: routes.judgeChairPersonRoute,
  [ROLES.PARTNER]: routes.partnerRoute,
}


const Content = (props: IContent) => {
  const history = useHistory()
  const role = mapRole(props.role)
  useEffect(() => {
    // if (role) {
    //   history.push('/' + role)
    // } 
    // else {
    //   history.push('/')
    // }
  }, [role])

  const getRoute = (routList: any, CurrentRoute: any) => {
    return routList?.map((route: any, idx: number) => {
      const { component: Component } = route
      return route.component && (
        <CurrentRoute
          key={idx}
          path={route.path}
          exact={route.exact}
          component={Component}
        />
      )
    })

  }
  return (
    <>
      <Loader variant="overlay" />
      <Suspense fallback={Loader}>
        <Switch>
          {getRoute(routes.onboardRoute, PublicRoute)}
          {getRoute(routes.commonRoute, PrivateRoute)}
          {role && getRoute(roleRoutes[role], PrivateRoute)}
        </Switch>
      </Suspense>
    </>
  )
}

export default React.memo(Content)
